import type { HausratDeckungsumfang } from '../../interfaces';
import type { VersicherungsdatenStepForms } from './versicherungsdaten-form.service';

/**
 * Listed field by field rather than spread: every step carries UI-only controls the DTO has no
 * field for, and a spread escapes the excess-property check that would otherwise catch them.
 */
export const mapVersicherungsdatenToDto = (
  value: VersicherungsdatenStepForms
): HausratDeckungsumfang => ({
  elementar: value.step8.elementar,
  glas: value.step8.glas,
  fahrraddiebstahlwert: value.step8.fahrraddiebstahlwert,

  // Automatisch ermitteln is the field being absent; the form already holds null for it, so this
  // only guards against a stale Wert surviving a switch back.
  versicherungssumme:
    value.step9.versicherungssummeModus === 'eigene' ? value.step9.versicherungssumme : null,
  selbstbeteiligung: value.step9.selbstbeteiligung,
  mindestsicherung: value.step9.mindestsicherung,
  ueberwachungsanlage: value.step9.ueberwachungsanlage,

  // A hidden section still has values — `getRawValue()` hands back disabled controls too — so the
  // reveal toggle, not the section itself, decides whether it goes on the wire.
  vorversicherung: value.step10.vorversicherungVorhanden ? value.step10.vorversicherung : null,
  vorschaeden: value.step10.schaedenVorhanden ? value.step10.vorschaeden : null,
});
